// import React from "react";
// import "./our_principles.css";
// // Import your images (update these paths with your actual image files)
// import onboardingImage from "../../img/des_sec/discover_features_1.svg";
// import customer from "../../img/des_sec/Customer-Centricity.png";
// import innovation from "../../img/des_sec/Innovation.png";
// import integrity from "../../img/des_sec/Integrity.png";
// import Collaboration from "../../img/des_sec/collabaration.png";
// import excellence from "../../img/des_sec/Excellence.png";
// import sustain from "../../img/des_sec/Sustainability.png";
// import dashboardImage from "../../img/des_sec/discover_features_6.svg";
// import complianceImage from "../../img/des_sec/discover_features_1.svg";
// import documentImage from "../../img/des_sec/discover_features_6.svg";
// import dividerImage from "../../img/des_sec/our_principles_dots.svg"; // This should be your dotted line image

// const OurPrinciples = () => {
//   return (
//     <div className="ourPrinciples-container-op">
//       {/* Background image would be set in CSS */}

//       <div className="ourPrinciples-content-op">
//         {/* Left Column */}
//         <div className="ourPrinciples-column-op left-column-op">
//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={customer}
//               alt="Onboarding illustration"
//               className="feature-image-op"
//             />
//           </div>
//           <div className="ourPrinciples-item-op text-item-op pb-4 pt-5">
//             <h2>Innovation </h2>
//             <p>
//             We embrace new ideas, pushing boundaries to create smarter solutions. Continuous improvement keeps us ahead in a changing world.
//             </p>
//           </div>
//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={integrity}
//               alt="Compliance illustration"
//               className="feature-image-op"
//             />
//           </div>
//           <div className="ourPrinciples-item-op text-item-op pb-4 pt-5">
//             <h2>Collaboration</h2>
//             <p>
//             We believe in teamwork, valuing diverse perspectives for better solutions. Strong partnerships drive mutual success and innovation.
//             </p>
//           </div>
//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={excellence}
//               alt="Compliance illustration"
//               className="feature-image-op"
//             />
//           </div>
//           <div className="ourPrinciples-item-op text-item-op pb-4 pt-5">
//             <h2>Sustainability</h2>
//             <p>
//             We build for the future, balancing business growth with social impact. Responsible practices drive long-term value for all.
//             </p>
//           </div>
         
//         </div>

//         {/* Middle Divider */}
//         <div className="ourPrinciples-divider-op">
//           <img src={dividerImage} alt="Divider" className="divider-image-op" />
//         </div>

//         {/* Right Column */}
//         <div className="ourPrinciples-column-op right-column-op">
//           <div className="ourPrinciples-item-op text-item-op pb-4">
//             <h2>Customer-Centricity</h2>
//             <p>
//             We put customers first, crafting solutions that meet their needs. Their success drives our innovation and service excellence.
//             </p>
//           </div>
//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={innovation}
//               alt="Dashboard illustration"
//               className="feature-image-op"
//             />
//           </div>
//           <div className="ourPrinciples-item-op text-item-op pb-4 pt-5">
//             <h2>Integrity</h2>
//             <p>
//             We act with honesty, transparency, and ethical responsibility. Trust is our foundation in every decision and partnership.
//             </p>
//           </div>

//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={Collaboration}
//               alt="Document management illustration"
//               className="feature-image-op"
//             />
//           </div>
//           <div className="ourPrinciples-item-op text-item-op pb-4 pt-5">
//             <h2>Excellence</h2>
//             <p>
//             We set high standards, ensuring quality in everything we do. Continuous learning and improvement fuel our pursuit of greatness.
//             </p>
//           </div>

          

//           <div className="ourPrinciples-item-op image-item-op">
//             <img
//               src={sustain}
//               alt="Document management illustration"
//               className="feature-image-op"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Main heading */}
//       <h1 className="main-heading-op">Our Principles</h1>
//     </div>
//   );
// };

// export default OurPrinciples;


// import React, { useRef, useEffect, useState } from "react";
// import { useSpring, animated } from 'react-spring';
// import "./our_principles.css";
// import onboardingImage from "../../img/des_sec/discover_features_1.svg";
// import customer from "../../img/des_sec/Customer-Centricity.png";
// import innovation from "../../img/des_sec/Innovation.png";
// import integrity from "../../img/des_sec/Integrity.png";
// import Collaboration from "../../img/des_sec/collabaration.png";
// import excellence from "../../img/des_sec/Excellence.png";
// import sustain from "../../img/des_sec/Sustainability.png";
// import dashboardImage from "../../img/des_sec/discover_features_6.svg";
// import complianceImage from "../../img/des_sec/discover_features_1.svg";
// import documentImage from "../../img/des_sec/discover_features_6.svg";
// import dividerImage from "../../img/des_sec/our_principles_dots.svg";

// const OurPrinciples = () => {
//   const [inView, setInView] = useState(false);
//   const containerRef = useRef(null);

//   // Intersection Observer to detect when the section is in view
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         setInView(entry.isIntersecting); // Update inView based on visibility
//       },
//       {
//         threshold: 0.1,
//         rootMargin: '0px 0px'
//       }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   // Animation for the main heading
//   const headingAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 300 : 0
//   });

//   // Animations for left column items
//   const leftColumnAnimation1 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 450 : 0
//   });
//   const leftColumnAnimation2 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 600 : 0
//   });
//   const leftColumnAnimation3 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 750 : 0
//   });
//   const leftColumnAnimation4 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 900 : 0
//   });
//   const leftColumnAnimation5 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1050 : 0
//   });
//   const leftColumnAnimation6 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1200 : 0
//   });

//   // Animations for right column items
//   const rightColumnAnimation1 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 600 : 0
//   });
//   const rightColumnAnimation2 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 750 : 0
//   });
//   const rightColumnAnimation3 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 900 : 0
//   });
//   const rightColumnAnimation4 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1050 : 0
//   });
//   const rightColumnAnimation5 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1200 : 0
//   });
//   const rightColumnAnimation6 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1350 : 0
//   });

//   // Animation for divider
//   const dividerAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(15px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1500 : 0
//   });

//   return (
//     <div className={`ourPrinciples-container-op ${inView ? 'animate-background' : ''}`} ref={containerRef}>
//       <div className="ourPrinciples-content-op">
//         {/* Left Column */}
//         <div className="ourPrinciples-column-op left-column-op">
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation1}>
//             <img src={customer} alt="Customer-Centricity illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation2}>
//             <h2>Innovation</h2>
//             <p>
//               We embrace new ideas, pushing boundaries to create smarter solutions. Continuous improvement keeps us ahead in a changing world.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation3}>
//             <img src={integrity} alt="Integrity illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation4}>
//             <h2>Collaboration</h2>
//             <p>
//               We believe in teamwork, valuing diverse perspectives for better solutions. Strong partnerships drive mutual success and innovation.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation5}>
//             <img src={excellence} alt="Excellence illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation6}>
//             <h2>Sustainability</h2>
//             <p>
//               We build for the future, balancing business growth with social impact. Responsible practices drive long-term value for all.
//             </p>
//           </animated.div>
//         </div>

//         {/* Middle Divider */}
//         <animated.div className="ourPrinciples-divider-op" style={dividerAnimation}>
//           <img src={dividerImage} alt="Divider" className="divider-image-op" />
//         </animated.div>

//         {/* Right Column */}
//         <div className="ourPrinciples-column-op right-column-op">
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4" style={rightColumnAnimation1}>
//             <h2>Customer-Centricity</h2>
//             <p>
//               We put customers first, crafting solutions that meet their needs. Their success drives our innovation and service excellence.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation2}>
//             <img src={innovation} alt="Innovation illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightColumnAnimation3}>
//             <h2>Integrity</h2>
//             <p>
//               We act with honesty, transparency, and ethical responsibility. Trust is our foundation in every decision and partnership.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation4}>
//             <img src={Collaboration} alt="Collaboration illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightColumnAnimation5}>
//             <h2>Excellence</h2>
//             <p>
//               We set high standards, ensuring quality in everything we do. Continuous learning and improvement fuel our pursuit of greatness.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation6}>
//             <img src={sustain} alt="Sustainability illustration" className="feature-image-op" />
//           </animated.div>
//         </div>
//       </div>

//       {/* Main heading */}
//       <animated.h1 className="main-heading-op" style={headingAnimation}>
//         Our Principles
//       </animated.h1>
//     </div>
//   );
// };

// export default OurPrinciples;

// import React, { useRef, useEffect, useState } from "react";
// import { useSpring, animated } from 'react-spring';
// import "./our_principles.css";
// import onboardingImage from "../../img/des_sec/discover_features_1.svg";
// import customer from "../../img/des_sec/Customer-Centricity.png";
// import innovation from "../../img/des_sec/Innovation.png";
// import integrity from "../../img/des_sec/Integrity.png";
// import Collaboration from "../../img/des_sec/collabaration.png";
// import excellence from "../../img/des_sec/Excellence.png";
// import sustain from "../../img/des_sec/Sustainability.png";
// import dashboardImage from "../../img/des_sec/discover_features_6.svg";
// import complianceImage from "../../img/des_sec/discover_features_1.svg";
// import documentImage from "../../img/des_sec/discover_features_6.svg";
// import dividerImage from "../../img/des_sec/our_principles_dots.svg";

// const OurPrinciples = () => {
//   const [inView, setInView] = useState(false);
//   const containerRef = useRef(null);

//   // Intersection Observer to detect when the section is in view
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         setInView(entry.isIntersecting); // Update inView based on visibility
//       },
//       {
//         threshold: 0.1,
//         rootMargin: '0px 0px'
//       }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   // Animation for the main heading
//   const headingAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(30px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 300 : 0
//   });

//   // Animations for left column items (slide from left)
//   const leftColumnAnimation1 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 500 : 0
//   });
//   const leftColumnAnimation2 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 700 : 0
//   });
//   const leftColumnAnimation3 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 900 : 0
//   });
//   const leftColumnAnimation4 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1100 : 0
//   });
//   const leftColumnAnimation5 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1300 : 0
//   });
//   const leftColumnAnimation6 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(-50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1500 : 0
//   });

//   // Animations for right column items (slide from right)
//   const rightColumnAnimation1 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 700 : 0
//   });
//   const rightColumnAnimation2 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 900 : 0
//   });
//   const rightColumnAnimation3 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1100 : 0
//   });
//   const rightColumnAnimation4 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1300 : 0
//   });
//   const rightColumnAnimation5 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1500 : 0
//   });
//   const rightColumnAnimation6 = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px)' : 'translateX(50px)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1700 : 0
//   });

//   // Animation for divider (scale and fade)
//   const dividerAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'scale(1)' : 'scale(0.8)',
//     config: { tension: 160, friction: 30, mass: 1 },
//     delay: inView ? 1900 : 0
//   });

//   return (
//     <div className={`ourPrinciples-container-op ${inView ? 'animate-background' : ''}`} ref={containerRef}>
//       <div className="ourPrinciples-content-op">
//         {/* Left Column */}
//         <div className="ourPrinciples-column-op left-column-op">
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation1}>
//             <img src={customer} alt="Customer-Centricity illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation2}>
//             <h2>Innovation</h2>
//             <p>
//               We embrace new ideas, pushing boundaries to create smarter solutions. Continuous improvement keeps us ahead in a changing world.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation3}>
//             <img src={integrity} alt="Integrity illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation4}>
//             <h2>Collaboration</h2>
//             <p>
//               We believe in teamwork, valuing diverse perspectives for better solutions. Strong partnerships drive mutual success and innovation.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={leftColumnAnimation5}>
//             <img src={excellence} alt="Excellence illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftColumnAnimation6}>
//             <h2>Sustainability</h2>
//             <p>
//               We build for the future, balancing business growth with social impact. Responsible practices drive long-term value for all.
//             </p>
//           </animated.div>
//         </div>

//         {/* Middle Divider */}
//         <animated.div className="ourPrinciples-divider-op" style={dividerAnimation}>
//           <img src={dividerImage} alt="Divider" className="divider-image-op" />
//         </animated.div>

//         {/* Right Column */}
//         <div className="ourPrinciples-column-op right-column-op">
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4" style={rightColumnAnimation1}>
//             <h2>Customer-Centricity</h2>
//             <p>
//               We put customers first, crafting solutions that meet their needs. Their success drives our innovation and service excellence.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation2}>
//             <img src={innovation} alt="Innovation illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightColumnAnimation3}>
//             <h2>Integrity</h2>
//             <p>
//               We act with honesty, transparency, and ethical responsibility. Trust is our foundation in every decision and partnership.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation4}>
//             <img src={Collaboration} alt="Collaboration illustration" className="feature-image-op" />
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightColumnAnimation5}>
//             <h2>Excellence</h2>
//             <p>
//               We set high standards, ensuring quality in everything we do. Continuous learning and improvement fuel our pursuit of greatness.
//             </p>
//           </animated.div>
//           <animated.div className="ourPrinciples-item-op image-item-op" style={rightColumnAnimation6}>
//             <img src={sustain} alt="Sustainability illustration" className="feature-image-op" />
//           </animated.div>
//         </div>
//       </div>

//       {/* Main heading */}
//       <animated.h1 className="main-heading-op" style={headingAnimation}>
//         Our Principles
//       </animated.h1>
//     </div>
//   );
// };

// export default OurPrinciples;

import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from 'react-spring';
import "./our_principles.css";
import onboardingImage from "../../img/des_sec/discover_features_1.svg";
import customer from "../../img/des_sec/Customer-Centricity.png";
import innovation from "../../img/des_sec/Innovation.png";
import integrity from "../../img/des_sec/Integrity.png";
import Collaboration from "../../img/des_sec/collabaration.png";
import excellence from "../../img/des_sec/Excellence.png";
import sustain from "../../img/des_sec/Sustainability.png";
import dashboardImage from "../../img/des_sec/discover_features_6.svg";
import complianceImage from "../../img/des_sec/discover_features_1.svg";
import documentImage from "../../img/des_sec/discover_features_6.svg";
import dividerImage from "../../img/des_sec/our_principles_dots.svg";

const OurPrinciples = () => {
  // State for container visibility (for background animation)
  const [containerInView, setContainerInView] = useState(false);
  const containerRef = useRef(null);

  // State and refs for individual items
  const [headingInView, setHeadingInView] = useState(false);
  const headingRef = useRef(null);
  const leftRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const rightRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const dividerRef = useRef(null);
  const [leftInView, setLeftInView] = useState([false, false, false, false, false, false]);
  const [rightInView, setRightInView] = useState([false, false, false, false, false, false]);
  const [dividerInView, setDividerInView] = useState(false);

  // Intersection Observer for container (background animation)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setContainerInView(entry.isIntersecting);
      },
      { threshold: 0.1, rootMargin: '0px 0px' }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Intersection Observer for heading
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setHeadingInView(entry.isIntersecting);
      },
      { threshold: 0.3, rootMargin: '0px 0px' }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);

  // Intersection Observers for left column items
  useEffect(() => {
    const observers = leftRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setLeftInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px' }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return observer;
    });

    return () => {
      leftRefs.forEach((ref, index) => {
        if (ref.current) {
          observers[index].unobserve(ref.current);
        }
      });
    };
  }, []);

  // Intersection Observers for right column items
  useEffect(() => {
    const observers = rightRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setRightInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px' }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return observer;
    });

    return () => {
      rightRefs.forEach((ref, index) => {
        if (ref.current) {
          observers[index].unobserve(ref.current);
        }
      });
    };
  }, []);

  // Intersection Observer for divider
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setDividerInView(entry.isIntersecting);
      },
      { threshold: 0.3, rootMargin: '0px 0px' }
    );

    if (dividerRef.current) {
      observer.observe(dividerRef.current);
    }

    return () => {
      if (dividerRef.current) {
        observer.unobserve(dividerRef.current);
      }
    };
  }, []);

  // Animation for the main heading
  const headingAnimation = useSpring({
    opacity: headingInView ? 1 : 0,
    transform: headingInView ? 'translateY(0px)' : 'translateY(30px)',
    config: { tension: 180, friction: 35, mass: 1 }
  });

  // Animations for left column items
  const leftAnimation1 = useSpring({
    opacity: leftInView[0] ? 1 : 0,
    transform: leftInView[0] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation2 = useSpring({
    opacity: leftInView[1] ? 1 : 0,
    transform: leftInView[1] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation3 = useSpring({
    opacity: leftInView[2] ? 1 : 0,
    transform: leftInView[2] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation4 = useSpring({
    opacity: leftInView[3] ? 1 : 0,
    transform: leftInView[3] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation5 = useSpring({
    opacity: leftInView[4] ? 1 : 0,
    transform: leftInView[4] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation6 = useSpring({
    opacity: leftInView[5] ? 1 : 0,
    transform: leftInView[5] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animations for right column items
  const rightAnimation1 = useSpring({
    opacity: rightInView[0] ? 1 : 0,
    transform: rightInView[0] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation2 = useSpring({
    opacity: rightInView[1] ? 1 : 0,
    transform: rightInView[1] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation3 = useSpring({
    opacity: rightInView[2] ? 1 : 0,
    transform: rightInView[2] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation4 = useSpring({
    opacity: rightInView[3] ? 1 : 0,
    transform: rightInView[3] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation5 = useSpring({
    opacity: rightInView[4] ? 1 : 0,
    transform: rightInView[4] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation6 = useSpring({
    opacity: rightInView[5] ? 1 : 0,
    transform: rightInView[5] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animation for divider
  const dividerAnimation = useSpring({
    opacity: dividerInView ? 1 : 0,
    transform: dividerInView ? 'scale(1)' : 'scale(0.8)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  return (
    <div className={`ourPrinciples-container-op ${containerInView ? 'animate-background' : ''}`} ref={containerRef}>
      <div className="ourPrinciples-content-op">
        {/* Left Column */}
        <div className="ourPrinciples-column-op left-column-op">
          <animated.div className="ourPrinciples-item-op image-item-op" style={leftAnimation1} ref={leftRefs[0]}>
            <img src={customer} alt="Customer-Centricity illustration" className="feature-image-op" />
          </animated.div>
          <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftAnimation2} ref={leftRefs[1]}>
            <h2>Innovation</h2>
            <p>
              We embrace new ideas, pushing boundaries to create smarter solutions. Continuous improvement keeps us ahead in a changing world.
            </p>
          </animated.div>
          <animated.div className="ourPrinciples-item-op image-item-op" style={leftAnimation3} ref={leftRefs[2]}>
            <img src={integrity} alt="Integrity illustration" className="feature-image-op" />
          </animated.div>
          <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftAnimation4} ref={leftRefs[3]}>
            <h2>Collaboration</h2>
            <p>
              We believe in teamwork, valuing diverse perspectives for better solutions. Strong partnerships drive mutual success and innovation.
            </p>
          </animated.div>
          <animated.div className="ourPrinciples-item-op image-item-op" style={leftAnimation5} ref={leftRefs[4]}>
            <img src={excellence} alt="Excellence illustration" className="feature-image-op" />
          </animated.div>
          <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={leftAnimation6} ref={leftRefs[5]}>
            <h2>Sustainability</h2>
            <p>
              We build for the future, balancing business growth with social impact. Responsible practices drive long-term value for all.
            </p>
          </animated.div>
        </div>

        {/* Middle Divider */}
        <animated.div className="ourPrinciples-divider-op" style={dividerAnimation} ref={dividerRef}>
          <img src={dividerImage} alt="Divider" className="divider-image-op" />
        </animated.div>

        {/* Right Column */}
        <div className="ourPrinciples-column-op right-column-op">
          <animated.div className="ourPrinciples-item-op text-item-op pb-4" style={rightAnimation1} ref={rightRefs[0]}>
            <h2>Customer-Centricity</h2>
            <p>
              We put customers first, crafting solutions that meet their needs. Their success drives our innovation and service excellence.
            </p>
          </animated.div>
          <animated.div className="ourPrinciples-item-op image-item-op" style={rightAnimation2} ref={rightRefs[1]}>
            <img src={innovation} alt="Innovation illustration" className="feature-image-op" />
          </animated.div>
          <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightAnimation3} ref={rightRefs[2]}>
            <h2>Integrity</h2>
            <p>
              We act with honesty, transparency, and ethical responsibility. Trust is our foundation in every decision and partnership.
            </p>
          </animated.div>
          <animated.div className="ourPrinciples-item-op image-item-op" style={rightAnimation4} ref={rightRefs[3]}>
            <img src={Collaboration} alt="Collaboration illustration" className="feature-image-op" />
          </animated.div>
          <animated.div className="ourPrinciples-item-op text-item-op pb-4 pt-5" style={rightAnimation5} ref={rightRefs[4]}>
            <h2>Excellence</h2>
            <p>
              We set high standards, ensuring quality in everything we do. Continuous learning and improvement fuel our pursuit of greatness.
            </p>
          </animated.div>
          <animated.div className="ourPrinciples-item-op image-item-op" style={rightAnimation6} ref={rightRefs[5]}>
            <img src={sustain} alt="Sustainability illustration" className="feature-image-op" />
          </animated.div>
        </div>
      </div>

      {/* Main heading */}
      <animated.h1 className="main-heading-op" style={headingAnimation} ref={headingRef}>
        Our Principles
      </animated.h1>
    </div>
  );
};

export default OurPrinciples;